import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { storeReferral } from "./referral-storage";
import { trackReferralVisit } from "./api";

export function useOtherStoreReferralTracking() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const refFromUrl = searchParams.get("ref");
    if (!refFromUrl) {
      return;
    }

    let cancelled = false;

    trackReferralVisit(refFromUrl)
      .then((result) => {
        if (cancelled || !result?.refCode) {
          return;
        }
        storeReferral(result.refCode, result.visitedAt);
      })
      .catch(() => {
        if (!cancelled) {
          storeReferral(refFromUrl);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams]);
}
